import { PointsBundle } from '../../types/PointsBundle';

import {
  defaultPointsGalateaBigPack,
  defaultPointsGalateaBiggerPack,
  defaultPointsGalateaMediumPack,
  defaultPointsGalateaSmallPack,
  goldenHourPointsSM,
} from './points.bundles';

export const galateaStarterPack: PointsBundle = {
  id: 'com.colt.app.points.cheapest',
  adjustEventId: 'p2ol19',
  tiers: 40,
  title: '40 Points',
  description: '40_points',
  tags: [],
};

export const galateaStarterPackLarge: PointsBundle = {
  // note we are using abandoned_cart product for starter pack large.
  // This means that the user can only purchase one of them since the other offer will become unavailable after this product ID is purchased
  id: 'com.colt.points.lg.abandoned_cart',
  adjustEventId: 'p2ol19',
  tiers: 300,
  title: '300 Points',
  description: '300_points',
  tags: [],
};

export const pointsMediumUpsell: PointsBundle = {
  id: 'com.colt.points.md.upsell',
  adjustEventId: 'p2ol19',
  tiers: 145,
  title: '145 Points',
  description: '',
  tags: [],
  offerDetails: {
    type: 'upsell',
    config: {
      basePoints: defaultPointsGalateaMediumPack.tiers,
      maxTimesAllowedPurchase: 1,
      upsellForBundleIds: [
        defaultPointsGalateaSmallPack.id,
        defaultPointsGalateaMediumPack.id,
        defaultPointsGalateaBigPack.id,
        defaultPointsGalateaBiggerPack.id,
      ],
    },
  },
};

export const pointsLargeUpsell: PointsBundle = {
  id: 'com.colt.points.lg.upsell',
  adjustEventId: 'p2ol19',
  tiers: 325,
  title: '325 Points',
  description: '',
  tags: [],
  offerDetails: {
    type: 'upsell',
    config: {
      basePoints: defaultPointsGalateaBigPack.tiers,
      maxTimesAllowedPurchase: 1,
      upsellForBundleIds: [
        defaultPointsGalateaSmallPack.id,
        defaultPointsGalateaMediumPack.id,
        defaultPointsGalateaBigPack.id,
        defaultPointsGalateaBiggerPack.id,
      ],
    },
  },
};

export const pointsUpsell550: PointsBundle = {
  id: 'com.colt.points.xl.discounted',
  adjustEventId: 'p2ol19',
  tiers: 550,
  title: '550 Points',
  description: '',
  tags: [],
  offerDetails: {
    type: 'upsell',
    config: {
      basePoints: defaultPointsGalateaBiggerPack.tiers,
      maxTimesAllowedPurchase: 1,
      upsellForBundleIds: [
        defaultPointsGalateaSmallPack.id,
        defaultPointsGalateaMediumPack.id,
        defaultPointsGalateaBigPack.id,
        goldenHourPointsSM.id,
      ],
    },
  },
};

export const pointsLargeAbandonedCart: PointsBundle = {
  id: 'com.colt.points.lg.abandoned_cart',
  adjustEventId: 'p2ol19',
  tiers: 300,
  title: '300 Points',
  description: '',
  tags: [],
  offerDetails: {
    type: 'abandonedCart',
    config: {
      basePoints: defaultPointsGalateaBigPack.tiers,
      maxTimesAllowedPurchase: 1,
      showForBundleIds: [
        defaultPointsGalateaSmallPack.id,
        defaultPointsGalateaMediumPack.id,
        defaultPointsGalateaBigPack.id,
        defaultPointsGalateaBiggerPack.id,
      ],
    },
  },
};

export const pointsLargeCountdownDoublePointsOffer: PointsBundle = {
  id: 'com.colt.points.lg.double_offer',
  adjustEventId: 'p2ol19',
  tiers: 500,
  title: '500 Points',
  description: '',
  tags: [],
};

export const pointsLargeBogoPointsOffer: PointsBundle = {
  id: 'com.colt.points.lg.bogo_offer',
  adjustEventId: 'p2ol19',
  tiers: 1100,
  title: '550 Points (BOGO)',
  description: '',
  tags: [],
};
